import React from 'react'
import SidebarPage from './components/SidebarPage'

export default function EmployeesSidebar() {
  return <SidebarPage />;
}
